(function () {
  function initHero(root) {
    if (!root || root.dataset.josReady === 'true') return;
    root.dataset.josReady = 'true';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-jos-slide]'));
    if (!slides.length) return;
    var current = 0;
    var timer;
    var interval = Math.max(1200, Number(root.dataset.slideDuration) || 3600);

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
    }

    function start() {
      if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      window.clearInterval(timer);
      timer = window.setInterval(function () { show(current + 1); }, interval);
    }

    show(0);
    start();
    root.addEventListener('mouseenter', function () { window.clearInterval(timer); });
    root.addEventListener('mouseleave', start);
    root.addEventListener('shopify:block:select', function (event) {
      var selected = event.target.closest('[data-jos-slide]');
      var index = slides.indexOf(selected);
      if (index > -1) show(index);
      window.clearInterval(timer);
    });
    root.addEventListener('shopify:block:deselect', start);
  }

  function initPanels(scope) {
    var panels = Array.prototype.slice.call(scope.querySelectorAll('.jos-service'));
    if (!panels.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify && window.Shopify.designMode) {
      panels.forEach(function (panel) { panel.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });
    panels.forEach(function (panel) { observer.observe(panel); });
  }

  function init(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-jos-hero]'), initHero);
    initPanels(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
